var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    "data-name": "Layer 1",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82 331.922a43.067 43.067 0 0 1 33-41.814 43 43 0 1 0 0 83.628 43.067 43.067 0 0 1 -33-41.814z",
    fill: "#d4e1f4",
    "data-original": "#D4E1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m424 351.922a23.026 23.026 0 0 1 13-20.709 23 23 0 1 0 0 41.418 23.027 23.027 0 0 1 -13-20.709z",
    fill: "#d4e1f4",
    "data-original": "#D4E1F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m452.011 163.128a25.706 25.706 0 0 0 -23.452 15.2c-8.464 18.958-16.1 25.684-20.074 25.684h-6.292a37.927 37.927 0 0 0 -37.884 37.888v.951a7 7 0 0 0 7 7h48.691v28.486a581.31 581.31 0 0 0 -64.686-31.979c-41.409-17.531-105.691-39.442-179.989-46.173l17.475-40.01a88.54 88.54 0 0 1 76.362-52.969 40.38 40.38 0 0 0 36.475 23.481h29.952a18.8 18.8 0 0 0 0-37.609h-61.482c-.108 0-.216 0-.325 0a102.54 102.54 0 0 0 -93.807 61.492l-44.915 102.807a7 7 0 1 0 12.829 5.605l21.516-49.25c74.32 6.039 138.85 27.931 180.124 45.376 45.476 19.223 73.36 37.348 73.634 37.527a7 7 0 0 0 10.837-5.855v-41.08a46.845 46.845 0 0 0 43.3-45.177l.4-15.023a25.7 25.7 0 0 0 -25.686-26.371zm-116.418-56.05a4.8 4.8 0 0 1 0 9.609h-29.952a26.239 26.239 0 0 1 -20.186-9.609zm127.717 97a32.893 32.893 0 0 1 -32.978 31.774h-51.248a23.929 23.929 0 0 1 23.109-17.835h6.292c11.737 0 22.792-11.431 32.857-33.976a11.694 11.694 0 0 1 22.36 5.094z",
    fill: "#0635c9",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635c9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1ae5be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m105 418.922a87 87 0 1 0 -87-87 87.1 87.1 0 0 0 87 87zm0-160a73 73 0 1 1 -73 73 73.082 73.082 0 0 1 73-72.999z",
    "data-original": "#1AE5BE",
    className: "active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427 418.922a67 67 0 1 0 -67-67 67.076 67.076 0 0 0 67 67zm0-120a53 53 0 1 1 -53 53 53.06 53.06 0 0 1 53-53z",
    "data-original": "#1AE5BE",
    className: "active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105 388.922a57 57 0 1 0 -57-57 57.064 57.064 0 0 0 57 57zm0-100a43 43 0 1 1 -43 43 43.049 43.049 0 0 1 43-43z",
    "data-original": "#1AE5BE",
    className: "active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427 388.922a37 37 0 1 0 -37-37 37.042 37.042 0 0 0 37 37zm0-60a23 23 0 1 1 -23 23 23.026 23.026 0 0 1 23-23z",
    "data-original": "#1AE5BE",
    className: "active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.8e577a703f16c10a33b1c5e5fcd6da8b.svg";
export { ForwardRef as ReactComponent };